<template>
  <div>
    <h3>Kasutustingimused</h3>
    <b-card>
      <b-card-text>
        <h4 class="text-left">1. Mõisted</h4>
        <p>
          Tingimustes kasutatud suure algustähega algavad terminid omavad järgnevat tähendust:
        </p>
        <p>
          <strong>“Tingimused”</strong> – käesolevad kasutustingimused, selle lisad ja mis tahes muud Teenusega seotud tingimused, millega Kasutaja Teenuste kasutamisel võib nõustuda.
        </p>
        <p>
          <strong>“Veebileht”</strong> - veebiaadressil www.haaleta.ee. „Kasutaja“ – isik, kes osaleb veebilehel www.haaleta.ee hääletustes.
        </p>
        <p>
          <strong>„Hääletus“</strong> – veebikeskkonnas läbi viidav küsitlus, millel kasutaja saab valida oma meelepäraseima vastuse.
        </p>
        <p>
          <strong>„Loosimine“</strong> – veebilehel hääletusele lisaks pakutav loosimäng, mille käigus loositakse kontakti jätnud vastajate vahel välja auhind, mis on esitletud konkreetse hääletuse juures.
        </p>

        <h4 class="text-left">2. Teenusepakkuja</h4>
        <p>
          Veebilehe haldaja ja Teenuste pakkuja on Postimees Grupp AS, mis on Eesti Vabariigi äriregistris registrikoodiga 10184643 registreeritud ettevõte.
        </p>

        <h4 class="text-left">3. Teenused</h4>
        <p>
          Hääleta pakub Kasutajale võimalust osaleda Veebilehe kaudu hääletustel ja seeläbi arvamust avaldada.
        </p>

        <h4 class="text-left">4. Teenuse kasutamine</h4>
        <p>
          Teenuste kasutamisel võivad kohalduda lisaks käesolevatele tingimustele ka vastava Loosimise tingimused ning kohalduvad Postimees Grupi isikuandmete töötlemise üldtingimused. Konkreetse Teenuse tingimustele on viidatud iga konkreetse hääletuse lehel ja Kasutaja nõustub hääletamisel kõikide väljatoodud tingimustega.
        </p>

        <h4 class="text-left">5. Privaatsustingimused</h4>
        <p>
          Kasutaja annab Postimees Grupile nõusoleku isikuandmete salvestamiseks, säilitamiseks, töötlemiseks ja esitamiseks vastavalt kehtivatele õigusaktidele ja Postimees Grupi isikuandmete töötlemise üldtingimustele.
        </p>
        <p>
          Postimees Grupp töötleb järgmiseid Kasutaja isikuandmeid: eesnimi, perekonnanimi, e-posti aadress, telefoni number, IP aadress ja küpsise andmed, eesmärgiga kindlustada võrdsed hääletamistingimused kõigile osalejatele ja viia läbi loosimine ning võitja loosimise tulemusest teavitamine.
        </p>
        <p>
        Pakkumise saamisega mitte nõustunud kasutajate andmed kustutatakse 1 (ühe) kuu jooksul peale loosimise lõppu. Pakkumise saamisega nõustunud kasutajate andmed kustutatakse vastava pöördumise esitamisel.
        </p>
        <p>
          Postimees Grupp võib jagada Kasutaja isikuandmeid kolmanda osapoolega, kui on tagatud, et infot kasutatakse Loosimise läbiviimise eesmärgil või nõusoleku andnud kasutajatele pakkumiste tegemiseks.
        </p>

        <h4 class="text-left">6. Vääramatu jõud</h4>
        <p>
          Postimees Grupp ei vastuta võimalike viivituste, tõrgete või katkestuste eest Teenuste osutamisel või Veebilehe kasutamisel, mida põhjustavad Postimees Grupi kontrolli alt väljas olevad asjaolud nagu force majeure, elektrikatkestused, häired Kasutaja või Postimees Grupi telefoni või Interneti ühenduses või muude elektrooniliste seadmete ja vahendite, sealhulgas tarkvara, töös.
        </p>

        <h2 class="text-left">7. Tingimuste muutmine</h2>
        <p>
          Postimees Grupil on igal ajal õigus muuta Tingimusi, Veebilehe sisu ja Teenuseid. Juba toimunud Hääletusele ja Loosimisele kehtivad tellimise ajal kehtinud Tingimused.
        </p>
        <p>
          Postimees Grupp teavitab Kasutajaid Tingimuste muutmisest, kuid ei vastuta selle eest, et Kasutaja sellist teadet loeb või sellest aru saab.
        </p>
        <p>
          Külastaja vastutab ise selle eest, et on tutvunud Veebilehe külastamise ajal kehtivate Tingimustega.
        </p>

        <h4 class="text-left">8. Kohaldatav õigus ja vaidluste lahendamine</h4>
        <p>
          Postimees Grupi ja Kasutaja vahelised vaidlused lahendatakse läbirääkimiste teel.
        </p>
        <p>
          Vaidlused, mida ei õnnestu lahendada läbirääkimiste teel, kuuluvad
        </p>
        <p>
          lahendamisele Harju maakohtus, kui õigusaktist ei tulene imperatiivselt teisiti.
        </p>
        <p>
          Tarbija võib esitada kaebuse ka tarbijakaebuste komisjonile.
        </p>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: "Terms"
  }
</script>